import { DatePipe, Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/lazy';
import { DataService } from '../DataService/data.service';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root',
})

export class CommonService {
  constructor(
    private datePipe: DatePipe,
    private alertController: AlertController,
    private dataService: DataService,
    private location: Location
  ) {
    this.overrideConsolelog();
    this.setPrototypes();
  }
  
  genUuid(): string {
    return uuid.v4();
  }

  overrideConsolelog() {
    const originalConsoleLog = console.log;
    console.log = (...args: any[]) => {
      const message = args.map(arg => typeof arg === 'object' ? '[OBJECT]' : String(arg)).join(' ');
      this.dataService.setErrorLog(message);
      originalConsoleLog.apply(console, args);
    };
  }

  getFormattedDate(date: string): string | null {
    return this.datePipe.transform(date, 'yyyy年MM月dd日');
  }

  async confirmBox(message: string): Promise<boolean> {
    const alert = await this.alertController.create({
      message,
      buttons: [{ text: 'OK', role: 'OK' }, { text: 'キャンセル', role: 'Cancel' }],
    });
    await alert.present();
    return alert.onDidDismiss().then(result => result.role === 'OK');
  }

  async messageBox(message: string) {
    const alert = await this.alertController.create({
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  keybordHide() {
    if (document.activeElement) {
      (document.activeElement as HTMLInputElement).blur();
    }
  }

  notPresent(msg: string = "この機能は実装されていません") {
    this.messageBox(msg);
  }

  setPrototypes() {
    String.prototype.getLineCount = function (): number {
      let valSrcArray = this.split(/\r?\n/);
      let lines = 0;
      for (let val of valSrcArray) {
        if (val.trim().length) lines++;
      }
      return lines
    }

    String.prototype.eraseHiphen = function () {
      return (this.replace(/-/g, ''))
    }

    String.prototype.zen2han = function () {
      return this.replace(/[Ａ-Ｚａ-ｚ０-９／－＾＋，．：；＿｛｝＠”＃＄％＆’（）！]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    }

    String.prototype.toKatakana = function () {
      return this.replace(/[\u3041-\u3096]/g, function (match) {
        var chr = match.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
      });
    }

    //--------------------------------------------------------------------------------------------------------
    // 引数に渡される文字列が郵便番号もしくは電話番号の形式と推定される場合に正確な位置にハイフンを
    // 付加して返すSrtingオブジェクトのプロトタイプ関数
    //
    // 総務省が公表している全国の市外局番情報を整形した配列（重複は除去している）
    // 市外局番の一覧（令和4年3月1日現在）
    // https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/shigai_list.html
    //
    // 2023-06-29 Inter Creative Systems ltd. Masaaki Nakamura
    //
    String.prototype.addHyphen = function () {
      const exPhone = [11, 123, 124, 125, 126, 1267, 133, 134, 135, 136, 1372, 1374, 137, 1377, 138, 1392, 139, 1397, 1398, 142,
        143, 144, 145, 1456, 1457, 146, 1466, 152, 153, 154, 1547, 15, 155, 1558, 156, 1564, 157, 158, 1586, 1587,
        162, 1632, 1634, 1635, 163, 164, 1648, 165, 1654, 1655, 1656, 1658, 166, 167, 172, 173, 174, 175, 176, 17,
        178, 179, 182, 183, 184, 185, 186, 187, 18, 191, 192, 193, 194, 195, 19, 197, 198, 22, 220, 223, 224, 225, 226,
        228, 229, 233, 234, 235, 23, 237, 238, 240, 241, 242, 243, 244, 24, 246, 247, 248, 25, 250, 254, 255, 256, 257,
        258, 259, 260, 261, 26, 263, 264, 265, 266, 267, 268, 269, 270, 27, 274, 276, 277, 278, 279, 280, 282, 283, 284,
        285, 28, 287, 288, 289, 291, 29, 293, 294, 295, 296, 297, 299, 3, 422, 42, 428, 4, 43, 436, 438, 439, 44, 45, 460,
        46, 463, 465, 466, 467, 470, 47, 475, 476, 478, 479, 48, 480, 49, 493, 494, 495, 4992, 4994, 4996, 4998, 52, 53,
        531, 532, 533, 536, 537, 538, 539, 54, 544, 545, 547, 548, 550, 551, 55, 553, 554, 555, 556, 557, 558, 561, 562,
        563, 564, 565, 566, 567, 568, 569, 572, 573, 574, 575, 576, 5769, 577, 578, 58, 581, 584, 585, 586, 587, 59, 594,
        595, 596, 597, 5979, 598, 599, 6, 72, 721, 725, 73, 735, 736, 737, 738, 739, 740, 742, 743, 744, 745, 746, 7468,
        747, 748, 749, 75, 761, 76, 763, 765, 766, 767, 768, 770, 771, 772, 773, 774, 77, 776, 778, 779, 78, 790, 791,
        79, 794, 795, 796, 797, 798, 799, 82, 820, 823, 824, 826, 827, 829, 83, 833, 834, 835, 836, 837, 838, 8387, 8388,
        8396, 845, 846, 847, 8477, 848, 84, 8512, 8514, 852, 853, 854, 855, 856, 857, 858, 859, 86, 863, 865, 866, 867,
        868, 869, 875, 877, 87, 879, 880, 883, 884, 885, 88, 887, 889, 892, 893, 894, 895, 896, 897, 898, 89, 92, 920, 93,
        930, 940, 942, 943, 944, 946, 947, 948, 949, 950, 952, 954, 955, 956, 957, 95, 959, 96, 964, 965, 966, 967, 968,
        969, 972, 973, 974, 97, 977, 978, 979, 98, 980, 9802, 982, 983, 984, 985, 986, 987, 9912, 9913, 99, 993, 994,
        995, 996, 9969, 997
      ];
      const regExHandy = /^0[5789]0[0-9]{4}[0-9]{4}$/; // 携帯電話などにマッチする正規表現
      const regExPhone = /^0[0-9]{9}$/;                // 一般電話番号にマッチする正規表現
      const regExZipcode = /^[0-9]{7}$/;               // 郵便番号にマッチする正規表現

      let val = this.replace(/-/g, '');
      let valLen = val?.length;

      switch (valLen) {
        case 7: return (regExZipcode.test(val) ? `${val.substring(0, 3)}-${val.substring(3)}` : this);
        case 10:
        case 11:
          if (regExHandy.test(val))
            return `${val.substring(0, 3)}-${val.substring(3, 7)}-${val.substring(7, 11)}`;
          else if (regExPhone.test(val)) {
            for (let i = 4; i > 0; i--) {
              if (exPhone.includes(Number(val.substring(1, i + 1))))
                return `${val.substring(0, i + 1)}-${val.substring(i + 1, i + 1 + 5 - i)}-${val.substring(6, 10)}`;
            }
            return this;
          } break;
        default: return this;
      }
      return this;
    }
  }

  // 追加: 画像の向きを修正するメソッド
  async fixImageOrientation(blob: Blob): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(blob);
      img.onload = async () => {
        //const imgBlob = await fetch(img.src).then(res => res.blob());
        //const orientation = await this.common.getOrientationFromEXIF(imgBlob);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        canvas.width = img.width;
        canvas.height = img.height;

        // 数年前にはこのコードが必要だったが、これが必要なくなったためコメントアウト
        // 近年のブラウザーではEXIFのOrientation情報を基に正しい方向で描画されるようになったので
        // 自前で回転させると余計におかしくなることが判明した。
        /*
        if ([5, 6, 7, 8].indexOf(orientation) > -1) {
          canvas.width = img.height;
          canvas.height = img.width;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }
        switch (orientation) {
          case 2:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.scale(-1, 1);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 3:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(180 * Math.PI / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 4:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.scale(1, -1);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 5:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(90 * Math.PI / 180);
            ctx.scale(1, -1);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 6:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(90 * Math.PI / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 7:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-90 * Math.PI / 180);
            ctx.scale(1, -1);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          case 8:
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-90 * Math.PI / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            break;
          default:
            ctx.drawImage(img, 0, 0);
            break; // デフォルトの変換
        }
        */
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((fixedBlob) => {
          if (fixedBlob) {
            resolve(fixedBlob);
          } else {
            reject(new Error('Blob conversion failed'));
          }
          URL.revokeObjectURL(img.src); // オブジェクトURLを解放
        }, 'image/jpeg');
      };
      img.onerror = (error) => {
        URL.revokeObjectURL(img.src); // エラー時にもオブジェクトURLを解放
        reject(error);
      };
    });
  }

  getOrientationFromEXIF(blob: Blob): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const view = new DataView(event.target?.result as ArrayBuffer);
        if (view.getUint16(0, false) !== 0xFFD8) {
          return resolve(-2); // Not a JPEG
        }
        const length = view.byteLength;
        let offset = 2;
        while (offset < length) {
          const marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) {
              return resolve(-1); // Not valid EXIF
            }
            const little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            const tags = view.getUint16(offset, little);
            offset += 2;
            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                return resolve(view.getUint16(offset + (i * 12) + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return resolve(-1); // Orientation not found
      };
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(blob); // Blobを読み込む部分
    });
  }

  diff(obj1: any, obj2: any): any {
    const result: any = {};

    function compare(obj1: any, obj2: any, diffObj: any = {}) {
      for (const key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          if (typeof obj1[key] === 'object' && obj1[key] !== null && typeof obj2[key] === 'object' && obj2[key] !== null) {
            diffObj[key] = {};
            compare(obj1[key], obj2[key], diffObj[key]);
          } else if (obj1[key] !== obj2[key]) {
            diffObj[key] = obj2[key];
          }
        }
      }

      for (const key in obj2) {
        if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
          diffObj[key] = obj2[key];
        }
      }
    }

    compare(obj1, obj2, result);
    return result;
  }

  navigateBackWithoutHistory() {
    this.location.back(); // 前のページに戻る
    this.location.replaceState(this.location.path()); //前のページに戻った時点でそのページで履歴を上書き
  }
}
